<template>
    <div class="scroll" style="width: 100%;" id="seccionImprimir2">
        <!-- {{institucion_General}} -->
        <div>
            <p class="font-semibold mt-3">{{ ComunicadoEnviar.tipoC }}</p>
            <!--Comunicacion general-->
                <div class="mt-5" v-if="ComunicadoEnviar.tipo_comunicacion == 1">
                <p class="letra2"><b>Curso:                 </b><span class="letra3">{{ ComunicadoEnviar.cursoReceptor.toUpperCase() }}</span></p>
                <p class="letra2" v-if="ComunicadoEnviar.id_group == 1"><b>Administrador Emisor:  </b><span class="letra3">{{ ComunicadoEnviar.emisor.toUpperCase() }}</span></p>
                <p class="letra2" v-if="ComunicadoEnviar.id_group == 6"><b>Docente Emisor:  </b><span class="letra3">{{ ComunicadoEnviar.emisor.toUpperCase() }}</span></p>
            </div>
            <!--Si el administrador envia al docente-->
            <div class="mt-5" v-if="ComunicadoEnviar.tipo_comunicacion == 2">
                <p class="letra2"><b>Docente:               </b><span class="letra3">{{ ComunicadoEnviar.usuario_receptor.toUpperCase() }}</span></p>
                <p class="letra2"><b>Administrador Emisor:  </b><span class="letra3">{{ ComunicadoEnviar.emisor.toUpperCase() }}</span></p>
            </div>
            <!--Comunicacion a estudiante-->
            <div class="mt-5" v-if="ComunicadoEnviar.tipo_comunicacion == 3">
                <!-- <p class="letra2"><b>Estudiante:     </b><span class="letra3">{{ ComunicadoEnviar.usuario_receptor.toUpperCase() }} - {{ ComunicadoEnviar.cursoReceptor.toUpperCase() }}</span></p> -->
                <p class="letra2"><b>Estudiante:     </b><span class="letra3">{{ ComunicadoEnviar.usuario_receptor.toUpperCase() }}</span></p>
                <p class="letra2" v-if="ComunicadoEnviar.id_group == 1"><b>Administrador Emisor:  </b><span class="letra3">{{ ComunicadoEnviar.emisor.toUpperCase() }}</span></p>
                <p class="letra2" v-if="ComunicadoEnviar.id_group == 6"><b>Docente Emisor:  </b><span class="letra3">{{ ComunicadoEnviar.emisor.toUpperCase() }}</span></p>
            </div>
            <div class="mt-5 flex" style="justify-content: flex-end;margin-right: 20px;">
                <div class="flex">
                    <p> 
                        <button class="btnV" @click="preImprimir()">
                            <feather-icon icon="PrinterIcon" svgClasses="h-4 w-4" class="ml-2" style="position: inherit;top:3px" />
                            <span class="ml-2">Imprimir</span>
                        </button>
                    </p>
                    <p class="ml-3"> 
                        <button class="btnV" v-if="ComunicadoEnviar.user_created == usuario.idusuario || usuario.id_group == 1">
                            <feather-icon icon="PrinterIcon" svgClasses="h-4 w-4" class="ml-2" style="position: inherit;top:3px" />
                            <span class="ml-1" @click="cambiarEstado(ComunicadoEnviar.id,0)">Finalizar Comunicación</span>
                        </button>
                    </p>
                </div>
            </div>
        </div>
        <!--DATOS DEL COMUNICADO Y FILES-->
        <div>
            <vs-divider class="mt-4"></vs-divider>
            <div class="mt-5">
                <div class="flex">
                    <vs-avatar class="letra2" style="margin-top: -1px;" icon-pack="feather" icon="icon-user" />
                    <div class="flex ml-4" style="flex-direction: column;">
                        <p class="letra2 font-bold">{{ ComunicadoEnviar.emisor.toUpperCase() }}</p>
                        <small class="letra2" style="opacity: 0.7;">{{   elapsedTime(ComunicadoEnviar.created_at) }}</small>
                    </div>
                </div>
            </div>
            <div class="mt-5">
                <p class="letra2" v-html="ComunicadoEnviar.mensaje">
                </p>
            </div>
            <div class="mt-5" v-if="arregloComunicadosFiles.length > 0">
                <vs-divider position="left"><p class="letra2 font-bold">1 Archivos adjuntos</p></vs-divider>
            </div>
            <div class="mt-5 flex" style="flex-wrap: wrap;" v-if="arregloComunicadosFiles.length > 0">
                <div class="adjunto flex" v-for="(tr,key) in arregloComunicadosFiles" :key="key">
                    <feather-icon icon="MenuIcon" style="color:white;" class="ml-2"/>
                    <div class="flex ml-5" style="flex-direction: column;">
                        <p class="letra2 mt-4 font-semibold">{{ tr.archivo.substring(0,20) }}</p>
                        <p class="letra2 download" @click="descargar_archivo(tr)" style="opacity:0.6">Descargar</p>
                    </div>
                </div>
            </div>
        </div>
        <!--FIN DATOS DEL COMUNICADO Y FILES-->
        <!--DATOS DE LAS RESPUESTAS Y FILES-->
        <div v-for="(tr,key) in arregloRespuestas" :key="key">
            <vs-divider class="mt-4"></vs-divider>
            <div class="mt-5">
                <div class="flex">
                    <vs-avatar class="letra2" style="margin-top: -1px;" icon-pack="feather" icon="icon-user" />
                    <div class="flex ml-4" style="flex-direction: column;">
                        <p class="letra2 font-bold">{{ tr.mensajero.toUpperCase() }}</p>
                        <small class="letra2" style="opacity: 0.7;">{{   elapsedTime(tr.created_at) }}</small>
                    </div>
                </div>
            </div>
            <div class="mt-5">
                <p class="letra2" v-html="tr.mensaje">
                </p>
            </div>
            <div class="mt-5" v-if="tr.files.length > 0">
                <vs-divider position="left"><p class="letra2 font-bold">1 Archivos adjuntos</p></vs-divider>
            </div>
            <div class="mt-5 flex" style="flex-wrap: wrap;" v-if="tr.files.length > 0">
                <div class="adjunto flex" v-for="(item,key) in tr.files" :key="key">
                    <feather-icon icon="MenuIcon" style="color:white;" class="ml-2"/>
                    <div class="flex ml-5" style="flex-direction: column;">
                        <p class="letra2 mt-4 font-semibold">{{ item.archivo.substring(0,20) }}</p>
                        <p class="letra2 download" @click="descargar_archivo(item)" style="opacity:0.6">Descargar</p>
                    </div>
                </div>
            </div>
        </div>
         <!--FIN DATOS DE LAS RESPUESTAS Y FILES-->
        <vs-divider class="mt-4"></vs-divider>
        <div v-if="ComunicadoEnviar.estado!=0">
            <div class="mt-5">
                <vs-textarea counter="500" @keyup.enter="guardarComunicacion()" label="Escriba su respuesta..." :counter-danger.sync="counterDanger" v-model="comunicado.mensaje" />
            </div>
            <div class="mt-2">
                <p class="font-bold letra2">Archivo Adjunto (Máximo 20 MB):</p>
                <p class="mt-2">
                    <input type="file" name="file1" id="file1" class="inputfile" style="display: none;" v-on:change="mostrarImg()">
                    <label for="file1" class="farchivo">
                        <feather-icon icon="UploadCloudIcon" svgClasses="h-4 w-4" class="ml-2" style="position: inherit;top:3px" /> <span class="ml-1 letra2">Buscar Archivo</span>
                    </label>
                </p>
            </div>
            <div class="flex mt-2">
                <div class="flex" v-for="(tr,key) in attachmentArray" :key="key"> 
                    <div class="flex" style="flex-direction: column;">
                        <img id="img1" v-if="tr.tipo == 'img'" width="100" class="img-responsive mb-2 ml-1" v-bind:src="tr.img" style="border-radius: 5px;max-height: 60px;">
                        <img v-else style="max-height: 60px;width: 50px;"  src="@/assets/images/file-icons/doc.png"/>
                        <small class="mt-1">{{ tr.name.substring(0,20) }}...</small>
                    </div>
                    <vs-button radius type="line"  @click="removeItemFromArr(attachmentArray,tr)" class="ml-2 mt-4" color="danger" icon="delete"></vs-button>
                </div>
            </div>
            <br>
            <div style="margin-top: -5px;" class="flex justify-center">
                <button class="boton">
                    <feather-icon icon="SendIcon" svgClasses="h-4 w-4" class="ml-1" style="position: relative;top: 3px;" />
                    <span class="ml-1" @click="guardarComunicacion()">Enviar Comunicación</span> 
                </button>
            </div>
            <br>
        </div>
        <div class="mt-5 letra4" v-if="ComunicadoEnviar.estado == 0">
            <p>!Esta comunicación está FINALIZADA, 
                y por lo tanto no se admite respuestas. 
                Las comunicaciones la puede finalizar 
                la persona que envía o se finalizan automáticamente después de 15 días 
                desde el día de envío.
            </p>
        </div>
    </div>
</template>
<script>
  import io from 'socket.io-client';
import axios from 'axios'
import html2pdf from "html2pdf.js"
export default{
    data(){
        return{
            id:0,
            comunicado:{
                mensaje:'',
            },
            counterDanger: false,
            attachmentArray:[],
            usuario:[],
            arregloComunicadosFiles:[],
            arregloRespuestas:[],
            tipoGrupo:'',
            emisor:'',
            receptor:'',
            socket:io(process.env.socket) 
        }
    },
    created(){
        let me = this
        me.usuario = JSON.parse(localStorage.getItem("usuario"))[0]
    },
    mounted(){
        let me = this;
        me.getComunicacionFiles()
        me.getRespuestasComunicados()
        if(me.ComunicadoEnviar.tipo_comunicacion == '1') {
            if(me.usuario.id_group == 1){
                me.tipoGrupo = 'general'   
                me.emisor = 0
            }
            if(me.usuario.id_group == 6){
                me.tipoGrupo = 'general'   
                me.emisor = me.usuario.idusuario
            }
            if(me.usuario.id_group == 4){
                me.tipoGrupo = 'individual'   
                me.emisor = me.usuario.idusuario
                if(me.ComunicadoEnviar.id_group == 1)  me.receptor = 0
                else  me.receptor = me.ComunicadoEnviar.user_created
            } 
        }                                         
        //tipo de comunicacion: a docente o estudiante
        if(me.ComunicadoEnviar.tipo_comunicacion == '2'  || me.ComunicadoEnviar.tipo_comunicacion == '3'){
            me.tipoGrupo = 'individual'
            if(me.usuario.id_group == 1){
            me.emisor = 0
            me.receptor = me.ComunicadoEnviar.receptor_id
            }
            if(me.usuario.id_group == 6 || me.usuario.id_group == 4){
                me.emisor = me.usuario.idusuario
                if(me.ComunicadoEnviar.id_group == 1)  me.receptor = 0
                else  me.receptor = me.ComunicadoEnviar.user_created
            }
        }
        //fin tipo de comunicacion a docente  o estudiante
    },
    props:{
        institucion_General:{
            type:Object,
            default:[]
        },
        ComunicadoEnviar:{
            type:Object,
            default:[]
        },
    },
    methods:{
        getComunicacionFiles(){
            let me = this
            this.$http.get(this.$server_url + 'listadoComunicaciones?listadoComunicacionesFiles=yes&comunicacion_id='+me.ComunicadoEnviar.id)
                .then(function (res) {
                    me.arregloComunicadosFiles = res.data
                })
                .catch(function (error) {
                    console.log(error + ' error');
                })
        },  
        getRespuestasComunicados(){
            let me = this
            this.$http.get(this.$server_url + 'listadoComunicaciones?listadoRespuestas=yes&comunicacion_id='+me.ComunicadoEnviar.id)
                .then(function (res) {
                    me.arregloRespuestas = res.data
                })
                .catch(function (error) {
                    console.log(error + ' error');
                })
        },
        guardarComunicacion(){
            let me = this;
            //validate campos vacios
            if(me.comunicado.mensaje.length < 5){
                me.$vs.notify({
                text:"Mínimo 5 caracteres",
                color:'warning',
                iconPack: 'feather',
                icon:'icon-check'})
                return
            }
            if(me.comunicado.mensaje.length >= 500){
                me.$vs.notify({
                text:"Máximo 500 caracteres en el mensaje",
                color:'warning',
                iconPack: 'feather',
                icon:'icon-check'})
                return
            }
            //files
            let imgsEnviar = []
            me.attachmentArray.forEach(element => {
                imgsEnviar.push(element.file)
            });
            me.$vs.loading()
            let formData = new FormData();
            formData.append('id',                       me.id);
            formData.append('tipo_comunicacion',        me.ComunicadoEnviar.tipo_comunicacion);
            formData.append('mensaje',                  me.comunicado.mensaje);
            formData.append('id_group',                 me.usuario.id_group);
            formData.append('usuario_id',               me.usuario.idusuario);
            formData.append('periodo_id',               me.institucion_General.periodo_id);
            formData.append('institucion_id',           me.institucion_General.idinstitucion)
            formData.append('comunicacion_id',          me.ComunicadoEnviar.id)
            for(let i=0; i<this.attachmentArray.length;i++){
                formData.append('archivos[]',              imgsEnviar[i]);
            }          
            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            axios.post(this.$data_url + 'api/guadarComunicacionesRespuesta', formData, config)
                .then(function (res) {
                    me.$vs.loading.close()
                    if(res.data.status == 0){
                        me.$vs.notify({
                        text:res.data.message,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-check',
                        time:7000
                        })
                        return
                    }
                    me.$vs.notify({
                    text:res.data.message,
                    color:'success',
                    iconPack: 'feather',
                    icon:'icon-check'})
                    document.getElementById("file1").value = '';
                    me.attachmentArray                     = []
                    var sendReceptor  = 0 
                    //COMUNICACION A DOCENTE
                    if(me.ComunicadoEnviar.tipo_comunicacion == 2){
                        if(me.usuario.id_group == 6){
                            sendReceptor = me.ComunicadoEnviar.user_created
                        }
                        if(me.usuario.id_group == 10){
                            sendReceptor = me.ComunicadoEnviar.receptor_id
                        }
                    }
                      //COMUNICACION A ESTUDIANTE
                      if(me.ComunicadoEnviar.tipo_comunicacion == 3){
                        //estudiante envia mensaje
                        if(me.usuario.id_group == 4){
                            sendReceptor = me.ComunicadoEnviar.user_created
                        }
                        //docente responde mensaje
                        if(me.usuario.id_group == 6){
                            sendReceptor = me.ComunicadoEnviar.receptor_id
                        }
                    }
                   
                    let datos = {
                        tipo_comunicacion:  me.ComunicadoEnviar.tipo_comunicacion,
                        emisor:             me.usuario.idusuario,
                        receptor:           sendReceptor,
                        grupoEmisor:        me.ComunicadoEnviar.id_group,
                        tipo:               "comunicacion",
                    }
                    me.sendSocket(datos)
                    me.getRespuestasComunicados()
                    me.limpiar()
                    //1 = por responder = aun no me han respondido;  
                    //2 = sin respuesta = aun no he respondido
                    me.actualizarEstadosMessage(me.ComunicadoEnviar.id)  
                })
                .catch(function (error) {
                    me.$vs.loading.close()
                })
        },
        sendSocket(datos){
            // console.log("d",datos)
            // try {
            // this.socket.emit("enviar", datos);
            // } catch (error) {
            //     console.log(error)
            // }
        },
        actualizarEstadosMessage(id,){
            let me = this
            this.$http.get(this.$server_url + 'cambiarEstadoMessage?grupo='+me.tipoGrupo+'&id='+id+'&emisor='+me.emisor+'&receptor='+me.receptor)
                .then(function (res) {
                    me.$emit('changeUpdate',true)
                })
                .catch(function (error) {
                    console.log(error + ' error');
                })
        },
        cambiarEstado(comunidacionId,estado){
            let me = this
            this.$http.get(this.$server_url + 'cambiarEstadoComunicado?id='+comunidacionId+'&estado='+estado)
                .then(function (res) {
                    if(res.data.estado == 0){
                        me.$vs.notify({
                        text:"Comunicación finalizada correctamente",
                        color:'success',
                        iconPack: 'feather',
                        icon:'icon-check'})
                        me.$emit('changeUpdate',true)
                    }
                })
                .catch(function (error) {
                    console.log(error + ' error');
                })
        },
        mostrarImg(){
            let me = this;
            var archivo = document.getElementById("file1").files[0];
            var tipo = ""
            if(archivo.type == "image/png" || archivo.type == "image/gif" || archivo.type == "image/jpeg" || archivo.type == "image/jpg") tipo = "img"
            else tipo = "other"
            var reader = new FileReader();
            if (me) {
                reader.readAsDataURL(archivo );
                reader.onloadend = function () {
                    var cal = new Object();
                    cal.file = archivo
                    cal.img  = reader.result
                    cal.tipo = tipo
                    cal.name = archivo.name
                    me.attachmentArray.push(cal)
                }
            }
        },
        removeItemFromArr (arr, item) {
            const i = arr.indexOf(item)
            arr.splice(i, 1)
        },
        preImprimir(){
            let me = this
            me.$vs.notify({
                text: "Espere mientras se va generando el archivo...",
                color: 'primary',
                iconPack: 'feather',
                icon: 'icon-file',
                time:5000
            })
            setTimeout(function() {me.imprimirEval()}, 1000)
        },
        imprimirEval(){
            let me = this
            var element = document.getElementById('seccionImprimir2');
            var opt = {
                margin:       0.5,
                filename:     me.nombrearchivo,
                image:        { type: 'jpeg', quality: 0.98 },
                html2canvas:  { 
                    scale: 3,
                },
                jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
            };
            html2pdf().from(element).set(opt).save();
        },
        descargar_archivo(item){
            let me = this
            window.open(this.$data_book+'archivos/comunicaciones/' + item.archivo, '_blank');
        },
        limpiar(){
            let me = this
            me.comunicado.mensaje = ""
            me.id                 = 0
        },  
        elapsedTime(startTime) {
            const x = new Date(startTime)
            const now = new Date()
            let timeDiff = now - x
            timeDiff /= 1000
            const seconds = Math.round(timeDiff)
            timeDiff = Math.floor(timeDiff / 60)
            const minutes = Math.round(timeDiff % 60)
            timeDiff = Math.floor(timeDiff / 60)
            const hours = Math.round(timeDiff % 24)
            timeDiff = Math.floor(timeDiff / 24)
            const days = Math.round(timeDiff % 365)
            timeDiff = Math.floor(timeDiff / 365)
            const years = timeDiff
            if (years > 0) {
                return `${years + (years > 1 ? ' Años ' : ' Año ')}`
            } else if (days > 0) {
                return `Hace ${days + (days > 1 ? ' Días ' : ' Día ')}`
            } else if (hours > 0) {
                return `Hace ${hours + (hours > 1 ? ' Horas ' : ' Hora ')}`
            } else if (minutes > 0) {
                return `Hace ${minutes + (minutes > 1 ? ' Minutos ' : ' Minuto ')}`
            } else if (seconds > 0) {
                return 'Hace '+ seconds + (seconds > 1 ? ' segundos' : 'justo ahora')
            }
            return ' Justo Ahora '
        },
    }
}
</script>
<style scoped>
*{
    font-family: 'Arial';
}
div.scroll {
    margin:4px, 4px;
    padding:4px;
    width: 100%;
    height: 88%;
    overflow-x: hidden;
    overflow-y: auto;
    text-align:justify;
}
.letra{
    font-size: 12px;
}
.letra2{
    font-size: 11px;
}
.letra3{
    font-weight: 100!important;
}
.letra4{
    font-size: 12px;
    color: #3EA0EA;
    text-align: center;
}
.btnV{
    color:#3E4448;
    background-color:#EBF3F8;
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    font-weight: 100;
    font-size: 11px;
    transition: 0.5s ease;
    cursor: pointer;
}
.btnV:hover{
    color: #3EA0EA;
}
.boton{
    background-color: #1c84c6;
    color: white;
    padding: 10px;
    border-color: #fff!important;
    width: 200px;
    cursor: pointer;
    transition: 0.5s ease-in;
    border: none;
    border-radius: 5px;
}
.farchivo{
    margin-bottom: -10px;
    cursor: pointer; color: gray; width: 100%; 
    font-size: 11px;
    line-height: 80%;
    transition: 0.5s ease all;
    padding: 10px 10px;
}
.farchivo:hover{
    background-color: #7C7B89;
    color:white;
    border-radius: 5px;
}
.adjunto{
    margin: 5px 10px;
    color:#3E4448;
    background-color:#EBF3F8;
    width: 30%;
    height: 53px;
    cursor: pointer;
    transition: 0.5s ease-in-out;
    border-radius: 5px;
}
.adjunto:hover{
    opacity: 0.8;
}
.download:hover{
    text-decoration: underline;
    opacity: 1;
}
/*RESPONSIVE*/
@media (max-width: 1280px) {
    .adjunto {
        width: 30%;
    }
}
@media (max-width: 1024px) {
    .adjunto {
        width: 30%;
    }
}
@media (max-width: 912px) {
    .adjunto {
        width: 40%;
    }
}
@media (max-width: 820px) {
    .adjunto {
        width: 40%;
    }
}

@media (max-width: 412px) {
    .adjunto {
        width: 100%;
    }
}
@media (max-width: 393px) {
    .adjunto {
        width: 100%;
    }
}
@media (max-width: 375px) {
    .adjunto {
        width: 100%;
    }
}
</style>